import {Injectable} from '@angular/core';
import {Service} from '../../common/service.class';
import {FellowshipOrPreceptorship} from './fellowship-or-preceptorship.model';
import {UserModelListService} from '../../common/user-model-list.service';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
@Injectable()
export class FellowshipOrPreceptorshipService extends UserModelListService<FellowshipOrPreceptorship> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'fellowshipOrPreceptorship', FellowshipOrPreceptorship);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/education/fellowship-or-preceptorship/fellowship-or-preceptorship.service.ts